// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import * as types from './action-types'

export function listRoles() {
  return { type: types.ROLES_FETCH_BEGIN }
}
